import { Avatar, FlexBox, InlineText } from '@helloself/hello-self-ui';

import { ProfileRecord } from '../../model/types';
import { getNameForAvatar } from './utils';

export type ListEntryProps = ProfileRecord;

const ListEntry = ({ iconUrl, name, organisation, startDate, endDate }: ListEntryProps) => {
    const subtext = organisation + (startDate ? ` | ${startDate} - ${endDate || 'Present'}` : '');
    const [firstName, lastName] = getNameForAvatar(organisation);
    return (
        <FlexBox gap={'12px'}>
            <Avatar
                size="48px"
                profile={{
                    firstName,
                    lastName,
                    profilePicture: iconUrl,
                }}
            />
            <FlexBox flexDirection="column" gap="6px">
                <InlineText lineHeight="22px" fontSize="16px" fontWeight="600">
                    {name}
                </InlineText>
                <InlineText lineHeight="18px" fontSize="14px">
                    {subtext}
                </InlineText>
            </FlexBox>
        </FlexBox>
    );
};

export default ListEntry;
